export const categories = [
  {
    id: "wanghong",
    name: "网红圈",
    slug: "wanghong",
    description: "网红主播、短视频博主最新爆料与内幕",
    articleCount: 128,
    icon: "ri-live-line",
  },
  {
    id: "yule",
    name: "娱乐圈",
    slug: "yule",
    description: "明星艺人、影视综艺圈内八卦速递",
    articleCount: 96,
    icon: "ri-movie-line",
  },
  {
    id: "shehui",
    name: "社会热点",
    slug: "shehui",
    description: "全网热议的社会新闻与民生话题",
    articleCount: 74,
    icon: "ri-global-line",
  },
  {
    id: "gaoxiao",
    name: "搞笑趣闻",
    slug: "gaoxiao",
    description: "沙雕日常、神评论与趣味段子",
    articleCount: 52,
    icon: "ri-emotion-laugh-line",
  },
  {
    id: "情感",
    name: "情感八卦",
    slug: "qinggan",
    description: "恋爱分手、婚姻纠葛与情感真相",
    articleCount: 83,
    icon: "ri-heart-line",
  },
  {
    id: "keji",
    name: "科技数码",
    slug: "keji",
    description: "科技公司内幕、产品爆料与行业揭秘",
    articleCount: 45,
    icon: "ri-smartphone-line",
  },
];